import Icon from '../../components/Icon'

Icon.register({
  'brands/cloudflare': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M407.9 319.9c12.2 0.6 22.2 5.5 28.2 13.9 6.5 9.1 8 21.5 4.1 34.9l-3.3 11.3c-0.7 2.3-2.8 4-5.3 4 0 0-0.1 0-0.1 0l-426.1-0.1c-2.3 0-4.1-1.7-4.4-3.9-0.7-4.6-1-9.2-1-14 0-52.4 41.9-95 94.2-96.5-1.4-5.4-2.1-11-2.1-16.8 0-37.6 30.5-68.1 68.1-68.1 15.4 0 29.6 5.1 41 13.7 20.5-59.6 77.1-102.3 143.6-102.3 72.2 0 132.6 50.4 148.1 117.9 0.1 0.5 0.2 1 0.2 1.6v0c0 0 0 0.1 0 0.1 0 1-0.2 2-0.5 2.8l-13.3 34.5c-10.5 27.2-40.4 49.5-68 50.8l-232.9 2.9c-2.5 0.2-4.6 1.8-5.4 4.1-0.2 0.5-0.3 1-0.3 1.6 0 0.9 0.3 1.8 0.8 2.6 0.8 1.1 2.1 1.9 3.6 1.9zM513.9 221.1c69.7 0 126.1 56.2 126.1 125.5 0 0 0 0.1 0 0.1 0 11.7-1.6 23.1-4.7 33.9-0.6 1.9-2.4 3.4-4.5 3.4h0-175.9c0 0-0.1 0-0.1 0-1.4-0.1-2.6-1.3-2.6-2.7 0-0.3 0.1-0.7 0.2-1l3.7-9.6c10.5-27.2 40.4-49.5 68.1-50.8l51.1-2.9c2.5-0.2 4.6-1.8 5.4-4.1 0.2-0.5 0.3-1 0.3-1.6 0-1-0.3-1.8-0.8-2.6-0.8-1.1-2.1-1.8-3.5-1.9l-49.2-2.9c-12.2-0.6-22.2-5.5-28.2-13.9-6.5-9.1-8-21.5-4.1-34.9l9.1-31.2c0.4-1.5 1.8-2.5 3.3-2.7 2.1-0.1 4.3-0.2 6.4-0.2z'
      }
    ]
  }
})
